export interface AdminNavItem {
  to: string;
  label: string;
}

export const ADMIN_NAV: AdminNavItem[] = [
  { to: '/', label: 'Dashboard' },
  { to: '/approvals', label: 'Approvals' },
  { to: '/bookings', label: 'Bookings & money' },
  { to: '/webhooks', label: 'Webhook health' },
  { to: '/hosts', label: 'Hosts' },
  { to: '/guests', label: 'Guests' },
  { to: '/content', label: 'Content & safety' },
  { to: '/finance', label: 'Finance export' },
  { to: '/ops', label: 'Ops' },
];

const PUBLIC_ADMIN_PATHS = ['/sign-in', '/sign-in/mfa'];

export function isPublicAdminPath(pathname: string): boolean {
  return PUBLIC_ADMIN_PATHS.includes(pathname);
}
